import {Flex, Heading, Stack, Text} from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';
import {useSelector} from 'react-redux';
import ButtonMinor from '../../../components/ButtonMinor';
import {Decline} from '../../../helpers/audioClips';
import {
  sendAudioClick,
  sendAudioClip,
} from '../../../vuplex';
import {
  fontFamily,
  getWorldTypeAccentColor,
  worldTypes,
} from './config';
import JcTag from './JcTag';
import WorldParticipants from './WorldParticipants';

const SpaceportWorldCard = ({
  onClick = () => {
  },
  accentColorOverride,
  bgOverride,
  world,
}) => {
  const {
    _id,
    blockedUserIds,
    isFull,
    joinCode,
    ownerId,
    participants,
    userIdsBlockedByUser = [],
  } = world;

  const userId = useSelector(s => s.inApp.userId);
  const currentWorld = useSelector(s => s.inApp.world) || {};
  const isCurrentWorld = currentWorld._id === _id;
  const isBlocked = _.includes(blockedUserIds, userId);
  const isDisabled = isCurrentWorld || isFull || isBlocked;
  const isPrivate = !!(world?.rules?.isPrivate || world?.isPrivate);
  const accentColor = accentColorOverride || getWorldTypeAccentColor(world);
  const worldType = world?.rules?.worldType;
  const participantsCount = _.size(participants);

  // currently using actual world.name to match raceSignup.roomName
  const worldName = {
    [worldTypes.craterRun]: 'Race Room',
    [worldTypes.spaceport]: 'Spaceport',
    [worldTypes.soloDressingRoom]: 'Solo Room',
  }[worldType];

  return (
    <ButtonMinor
      bg={bgOverride || 'none'}
      border={`2px solid ${accentColor}`}
      borderRadius="none"
      fontWeight="bold"
      h={worldType === worldTypes.soloDressingRoom ? '5em' : '7em'}
      p={0}
      onClick={(evt) => {
        if (isDisabled) {
          sendAudioClip({
            clip: Decline,
            ...evt,
          });
          return;
        }
        onClick(world);
        sendAudioClick(evt);
      }}
      world={world}
      w="full"
    >
      <Stack
        fontFamily="Saira Condensed"
        p={2}
        margin={0}
        h="100%"
        w="full"
        gap={3}
      >
        <Heading
          color="white"
          size="md"
          fontFamily="Saira Condensed"
          display="flex"
          justifyContent="space-between"
        >
          <Text fontFamily="Saira Variable">
            {worldName} {joinCode}
          </Text>

          <Flex gap={2}>
            {isPrivate && (
              <JcTag
                color="privateOrange"
                label="private"
                tooltip="Only invited people can join this room"
              />
            )}

            {isCurrentWorld
              ? (
                <JcTag
                  color={accentColor}
                  label="✔ you are here"
                  tooltip="You're already in this room"
                />
              ) : isBlocked
                ? (
                  <JcTag
                    color="#ef4b44"
                    label="blocked"
                    tooltip="The owner of this room blocked you.<br>Try creating or joining another room."
                  />
                ) : isFull
                  ? (
                    <JcTag
                      color="#ef4b44"
                      label="8/8"
                      tooltip="This room full.<br>Try creating or joining another room."
                    />
                  )
                  : null
            }

            {worldType !== worldTypes.soloDressingRoom && !isFull && (
              <Text>
                {participantsCount}/8
              </Text>
            )}
          </Flex>
        </Heading>

        <WorldParticipants
          ownerId={ownerId}
          participants={participants}
          userIdsBlockedByUser={userIdsBlockedByUser}
        />
      </Stack>
    </ButtonMinor>
  );
};

export default SpaceportWorldCard;
